/**
 * A file given as the answer to a form's file field.
 *
 * Path: orgs/{orgId}/attestations/{uid}/{assignmentId}/{fileName}
 * (firebase/storage.rules). The URL is the stored answer.
 */

import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { app } from '../../lib/firebase';
import { evidenceFileProblem, safeFileName, EVIDENCE_ACCEPT } from '../competencies/uploadEvidence';

export { EVIDENCE_ACCEPT as ANSWER_ACCEPT };
export const answerFileProblem = evidenceFileProblem;

export async function uploadAnswerFile(orgId: string, uid: string, assignmentId: string, file: File): Promise<string> {
  const path = `orgs/${orgId}/attestations/${uid}/${assignmentId}/${Date.now()}-${safeFileName(file.name)}`;
  const target = ref(getStorage(app), path);
  await uploadBytes(target, await file.arrayBuffer(), { contentType: file.type });
  return getDownloadURL(target);
}
